import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { deviceUtils, snackbarUtils } from "../../utils";
import { useDeviceBrands } from "../../hooks/useDevices";
import { useCreateDevice } from "../../hooks/useDevices";

export default function DeviceAddDialog(props) {
  const { open, handleClose } = props;
  const [device_name, setDeviceName] = useState("");
  const [dev_eui, setDevEUI] = useState("");
  const [app_eui, setAppEUI] = useState("");
  const [app_key, setAppKey] = useState("");
  const lns_id = 1;
  const [device_brand, setDeviceBrand] = useState("");
  const [region, setRegion] = useState("EU868");

  const { data: device_brands } = useDeviceBrands();
  const createDeviceMutation = useCreateDevice();

  const addDevice = () => {
    //check name is not blank, dev_eui is 16 chars, app_eui is 16 chars, app_key is 32 chars and device_brand is not blank
    if (!device_name) {
      snackbarUtils.updateMessage("Device name cannot be blank");
      return;
    }

    //check device brand is not non_lora = 1
    //get device brand
    let brand = device_brands?.find((brand) => brand.id === device_brand);
    if (brand?.non_lora === 0) {
      if (dev_eui.length !== 16) {
        snackbarUtils.updateMessage("Device EUI must be 16 characters");
        return;
      }

      if (app_eui.length !== 16) {
        snackbarUtils.updateMessage("App EUI must be 16 characters");
        return;
      }

      if (app_key.length !== 32) {
        snackbarUtils.updateMessage("App Key must be 32 characters");
        return;
      }
    }

    if (!device_brand) {
      snackbarUtils.updateMessage("Device brand cannot be blank");
      return;
    }

    const data = {
      name: device_name,
      dev_eui: dev_eui,
      app_eui: app_eui,
      app_key: app_key,
      lns_id: lns_id,
      device_brand_id: device_brand,
      region: region,
    };

    createDeviceMutation.mutate(data, {
      onSuccess: (response) => {
        snackbarUtils.updateMessage("Device added");
        deviceUtils.downloadQRCode(response.claim_code, device_name);
        handleClose();
      },
      onError: (error) => {
        if (error.response?.status === 409) {
          snackbarUtils.updateMessage("Device already exists");
        } else {
          snackbarUtils.updateMessage("Device add error");
        }
      },
    });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add Device</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <TextField
            id="deviceName"
            label="Device Name"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            autoFocus
            onChange={(e) => {
              setDeviceName(e.target.value);
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            id="device_brand"
            label="Device Brand"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            select
            onChange={(e) => {
              setDeviceBrand(e.target.value);
            }}
          >
            {device_brands &&
              device_brands.map((brand) => {
                return (
                  <MenuItem key={brand.id} value={brand.id}>
                    {brand.description}
                  </MenuItem>
                );
              })}
          </TextField>
        </FormControl>

        <FormControl fullWidth>
          <TextField
            id="dev_eui"
            label={
              device_brand &&
              device_brands.find((brand) => brand.id === device_brand).non_lora
                ? "Device ID"
                : "Dev EUI"
            }
            variant="outlined"
            margin="normal"
            required
            fullWidth
            onChange={(e) => {
              setDevEUI(e.target.value);
            }}
          />
        </FormControl>

        {
          //if device brand non_lora=0 then show these fields
          device_brand &&
            !device_brands.find((brand) => brand.id === parseInt(device_brand))
              .non_lora && (
              <>
                <FormControl fullWidth>
                  <TextField
                    id="app_eui"
                    label="App EUI"
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    onChange={(e) => {
                      setAppEUI(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <TextField
                    id="app_key"
                    label="App Key"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    onChange={(e) => {
                      setAppKey(e.target.value);
                    }}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <TextField
                    id="Region"
                    label="Region"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    select
                    onChange={(e) => {
                      setRegion(e.target.value);
                    }}
                  >
                    <MenuItem key="EU868" value="EU868">
                      EU868
                    </MenuItem>
                    <MenuItem key="US915" value="US915">
                      US915
                    </MenuItem>
                    <MenuItem key="AU915" value="AU915">
                      AU915
                    </MenuItem>
                  </TextField>
                </FormControl>
              </>
            )
        }
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={addDevice}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
